module.exports = __webpack_public_path__ + "static/media/text-height.1a98f86a.svg";